import { useState } from 'react';
import InstrumentList from '../../components/admin/instruments/InstrumentList';
import InstrumentForm from '../../components/admin/instruments/InstrumentForm';
import Button from '../../components/shared/UI/Button';

export default function InstrumentsPage() {
  const [view, setView] = useState('list');
  const [selectedInstrument, setSelectedInstrument] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  function handleSaved() {
    setView('list');
    setSelectedInstrument(null);
    setRefreshKey(k => k + 1);
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Instrument Types</h1>
          <p>Configure investment instrument types and their return mechanics per fund.</p>
        </div>
      </div>

      {view === 'list' && (
        <InstrumentList
          key={refreshKey}
          onAdd={() => { setSelectedInstrument(null); setView('add'); }}
          onEdit={(inst) => { setSelectedInstrument(inst); setView('edit'); }}
        />
      )}

      {(view === 'add' || view === 'edit') && (
        <div>
          <div style={{ marginBottom: 20 }}>
            <Button variant="ghost" onClick={() => { setView('list'); setSelectedInstrument(null); }}>
              ← Back to Instruments
            </Button>
          </div>
          <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 20 }}>
            {view === 'add' ? 'Add Instrument Type' : `Edit: ${selectedInstrument?.name}`}
          </h2>
          <InstrumentForm
            instrument={view === 'edit' ? selectedInstrument : null}
            onSaved={handleSaved}
            onCancel={() => { setView('list'); setSelectedInstrument(null); }}
          />
        </div>
      )}
    </div>
  );
}
